
export default function Footer() {
  return (
    <footer id="contacto" className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
              Dr. Cirugía Robótica
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Especialista en cirugía robótica y láser urológica con más de 15 años de experiencia. 
              Ofrecemos tratamientos de vanguardia con tecnología da Vinci y láser CO2 para 
              garantizar los mejores resultados a nuestros pacientes.
            </p>
            
            <div className="bg-gray-800 rounded p-3 mb-6 border-l-4 border-teal-400">
              <div className="flex items-center">
                <i className="ri-shield-check-line text-teal-400 mr-2 text-sm"></i>
                <span className="text-gray-300 text-xs">
                  AVISO COFEPRIS: 2133300201A0077
                </span>
              </div>
            </div>
            
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full flex items-center justify-center hover:opacity-80 transition-colors cursor-pointer" style={{ backgroundColor: '#20C6B2' }}>
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full flex items-center justify-center hover:opacity-80 transition-colors cursor-pointer" style={{ backgroundColor: '#1A1A1A' }}>
                <i className="ri-twitter-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors cursor-pointer">
                <i className="ri-youtube-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Robótica de Próstata
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Robótica de Riñón
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Tratamiento Disfunción Eréctil
                </a>
              </li>
              <li>
                <a href="#papiloma-center" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Papiloma Center - VPH
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Láser Urológica
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Reconstructiva
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">Contacto</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-3 mt-1" style={{ color: '#20C6B2' }}></i>
                <div>
                  <p className="text-gray-300">
                    Hospital Real San José Valle Real<br />
                    Consultorio 10B<br />
                    Valle Real, Zapopan, Jalisco
                  </p>
                </div>
              </div>
              
              <div className="flex items-center">
                <i className="ri-phone-line mr-3" style={{ color: '#20C6B2' }}></i>
                <a href="tel:+523333958988" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  +52 33 3395 8988
                </a>
              </div>
              
              <div className="flex items-center">
                <i className="ri-whatsapp-line text-green-400 mr-3"></i>
                <a href="https://wa.me/523333958988" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  WhatsApp: +52 33 3395 8988
                </a>
              </div>
              
              <div className="flex items-center">
                <i className="ri-mail-line mr-3" style={{ color: '#20C6B2' }}></i>
                <a href="mailto:consultas@cirugiarobotica.com" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  consultas@cirugiarobotica.com
                </a>
              </div>
              
              <div className="flex items-start">
                <i className="ri-time-line mr-3 mt-1" style={{ color: '#20C6B2' }}></i>
                <div className="text-gray-300">
                  <p>Lunes a Viernes: 9:00 AM - 6:00 PM</p>
                  <p>Sábados: 9:00 AM - 2:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Dr. Especialista en Cirugía Robótica. Todos los derechos reservados.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Políticas de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Términos y Condiciones
              </a>
              <a href="https://citadoctor.com.mx" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Hecho por CitaDoctor
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
